import React, { lazy } from 'react';
export function ExpertSection() {
  return <section className="w-full py-12 bg-gray-900 text-white px-4" data-id="element-110">
      <div className="max-w-4xl mx-auto" data-id="element-111">
        <div className="flex flex-col md:flex-row items-center" data-id="element-112">
          <div className="md:w-1/3 mb-6 md:mb-0" data-id="element-113">
            <div className="w-56 h-56 rounded-full overflow-hidden bg-white mx-auto" data-id="element-114">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jk7yyNMjhbeXbuMrMoCjHn/Doctor_sitting_at_the_desk.jpg" alt="Dr. John Nash" className="w-full h-full object-cover" loading="lazy" width="224" height="224" decoding="async" data-id="element-115" />
            </div>
          </div>
          <div className="md:w-2/3 md:pl-8" data-id="element-116">
            <h2 className="text-2xl font-bold mb-4" data-id="element-117">Dr. John Nash</h2>
            <h3 className="text-xl mb-4" data-id="element-118">
              Male Hair Loss & Scalp Health Restoration Specialist
            </h3>
            <p className="mb-4" data-id="element-119">
              "Dr. John Nash is a hair loss expert with over 10 years of
              specialized experience in male pattern hair loss. He serves as
              head research coordinator at the country's leading Hair Health
              Institutes, where he's recognized as an expert in both dermatology
              and trichology."
            </p>
            <p data-id="element-120">
              "In this presentation, he reveals his breakthrough discovery that
              addresses the environmental causes of modern hair loss for lasting
              follicular revival."
            </p>
          </div>
        </div>
      </div>
    </section>;
}
export default {
  ExpertSection
};